import styled from "styled-components";

const UpdateImageItemStyled = styled.div`

`;

export default UpdateImageItemStyled;